import { HeroText } from "./HeroText";
import "../styles/Header.css";
export function Header() {
  return (
    <>
      <header id="home">
        <HeroText />
      </header>
    </>
  );
}
